<template>
  <div>
    <span v-for="item in list" :key="item.value" @click="changeType(item)">
      <van-button v-if="item.select" type="info" size="small">{{ item.text }}</van-button>
      <van-button v-if="!item.select" plain type="default" size="small">{{ item.text }}</van-button>
    </span>
  </div>
</template>
<script>
import { Button } from 'vant'

export default {
  components: {
    [Button.name]: Button
  },
  props: {
    // eslint-disable-next-line
    typelist:undefined,
    // eslint-disable-next-line
    value:undefined
  },
  data() {
    return {
      list: []
    }
  },
  watch: {
    typelist(newValue, oldValue) {
      this.list = newValue
    }
  },
  created() {
    this.list = this.typelist
  },
  methods: {
    changeType(Selectvalue) {
      this.list.forEach(item => {
        if (item.value === Selectvalue.value) {
          if (item.select) {
            item.select = undefined
            this.$emit('input', undefined)
          } else {
            item.select = true
            this.$emit('input', Selectvalue)
          }
        } else {
          item.select = undefined
        }
      })
      this.list = JSON.parse(JSON.stringify(this.list))
    }
  }
}
</script>
<style scoped>
button{
  margin: 0.25em 0.5em 0.25em 0;
}
</style>
